import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

const AnomalyDetectionResource = {
  getFieldStatistics: (sensorId: number, field: string, startDate: string, endDate: string) =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/sensors/${sensorId}/get_field_statistics`, {
      field,
      start_date: startDate,
      end_date: endDate,
    }),

  getAnomalyDetectionPages: (
    page: number,
    items: number,
    sensor_id: string,
    variation_level: string,
    analysis_date: string,
  ) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/anomaly_detectors?page=${page}&items=${items}&sensor_id=${sensor_id}&variation_level=${variation_level}&analysis_date=${analysis_date}`,
    ),
}

export default AnomalyDetectionResource
